import React, { useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { selectUserBadge } from 'src/features/selector'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { actions as swapOrReturnActions } from 'src/features/swap-or-return/SwapOrReturnState'
import { CancelReceivementModal } from '../CancelReceivementModal/CancelReceivementModal'
import { ChangePositionModal } from '../ChangePositionModal/ChangePositionModal'
import { createColumns } from './QueueTab.columns'
import * as S from './QueueTab.styles'
import { createRowData } from './QueueTab.utils'

interface QueueTabProps {
  receivementsQueue: any[],
  updateCurrentTab: any
}

export const QueueTab = ({
  receivementsQueue,
  updateCurrentTab,
}: QueueTabProps) => {
  const user = useSelector(selectUserBadge)
  const dispatch = useDispatch()
  const history = useHistory()
  const { fc } = useFulfillmentCenter()

  const [openModalRemoveProviderQueue, setOpenModalRemoveProviderQueue] = useState(false)
  const [openModalChangePosition, setOpenModalChangePosition] = useState(false)
  const [queueRow, setQueueRow] = useState({
    receivement_id: 0,
    position: 0,
    supplier: '',
  })

  const handleCloseModalRemoveSupplierQueue = () => {
    setOpenModalRemoveProviderQueue((prevState) => !prevState)
  }

  const handleModalChangePosition = () => {
    setOpenModalChangePosition((prevState) => !prevState)
  }

  const tableSize = useMemo(
    () => (receivementsQueue.length < 10 ? 10 : receivementsQueue.length), [receivementsQueue],
  )

  const columns = useMemo(() => createColumns((supplierName: string) => {
    if (fc?.id) {
      const searchData = {
        fulfillmentCenterId: fc.id,
        supplierName,
        invoice: '',
        typesIds: [],
        status: [
          'OPEN',
          'IN_RESOLUTION',
          'WAITING_RELEASE',
        ],
        page: 1,
        perPage: 25,
      }

      dispatch(swapOrReturnActions.getSwapsOrReturns(searchData))
      history.push('/swap-or-return/manage', { fromQueue: true })
    }
  }), [fc, dispatch, history])

  return (
    <>
      <S.Wrapper>
        <ReactTable
          style={{ height: '100%' }}
          data={receivementsQueue.map(
            (data) => createRowData(
              data,
              setQueueRow,
              setOpenModalChangePosition,
              setOpenModalRemoveProviderQueue,
            ),
          )}
          showPagination={false}
          columns={columns as any}
          defaultPageSize={tableSize}
          pageSize={tableSize}
          className='-striped -highlight'
          previousText='Anterior'
          nextText='Próxima'
          loadingText='Carregando...'
          noDataText='Sem registros'
          pageText='Página'
          ofText='de'
          rowsText='Registros'
        />
      </S.Wrapper>
      <CancelReceivementModal
        user={user}
        queueRow={queueRow}
        updateCurrentTab={updateCurrentTab}
        handleCloseModalRemoveSupplierQueue={handleCloseModalRemoveSupplierQueue}
        openModalRemoveProviderQueue={openModalRemoveProviderQueue}
      />

      <ChangePositionModal
        user={user}
        handleModalChangePosition={handleModalChangePosition}
        openModalChangePosition={openModalChangePosition}
        queueRow={queueRow}
        updateCurrentTab={updateCurrentTab}
      />
    </>
  )
}
